<div class="row main-content">
	<div class="col-12 content">
		<h6 class="content-text">Your form has been successfully submitted. We will reach out to you soon for further
			process.</h6>
		<h6 class="content-text">Thank you for your time. Have a good day!</h6>
		<button type="submit" mat-raised-button class="add-button-css" (click)="close()">Close</button>
	</div>
</div>